import { redirect, type RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { cardsLoader } from './cards-loader';
import { createCardLoader } from './create-card-loader';

export const cardsRoutes: RouteObject = {
  loader: cardsLoader,
  children: [
    {
      path: '/cards',
      lazy: lazyComponent(() => import('@pages/client/card/cards-page'), 'CardsPage'),
    },
    {
      path: '/cards/new',
      loader: createCardLoader,
      lazy: lazyComponent(
        () => import('@pages/client/card/create-card-page'),
        'CreateCardPage',
      ),
    },
    {
      path: '/cards/new/virtual',
      loader: createCardLoader,
      lazy: lazyComponent(
        () => import('@pages/client/card/create-virtual-card-page'),
        'CreateVirtualCardPage',
      ),
    },
    {
      path: '/cards/new/physical',
      loader: createCardLoader,
      lazy: lazyComponent(
        () => import('@pages/client/card/request-plastic-card-page'),
        'RequestPlasticCardPage',
      ),
    },
    {
      path: '/cards/:id',
      lazy: lazyComponent(
        () => import('@pages/client/card/card-details-page'),
        'CardDetailsPage',
      ),
    },

    // ось це правильний роут, всередині він тягне все з фіч самого ліміту, бо він і є лімітом
    {
      path: '/cards/:id/limit/new',
      lazy: lazyComponent(
        () => import('@pages/client/card/create-limit-page'),
        'CreateLimitPage',
      ),
    },
    {
      path: '/cards/:id/limit/edit/:limitId',
      lazy: lazyComponent(
        () => import('@pages/client/card/edit-limit-page'),
        'EditLimitPage',
      ),
    },
    {
      path: '/cards/limit-templates/:id',
      lazy: lazyComponent(
        () => import('@pages/client/card/cards-limit-template-page'),
        'CardsLimitTemplatePage',
      ),
    },
    {
      path: '/cards/limit-templates',
      lazy: lazyComponent(
        () => import('@pages/client/card/cards-limit-templates-page'),
        'CardsLimitTemplatesPage',
      ),
      children: [
        {
          index: true,
          loader: ({ request }: { request: Request }) => {
            const url = new URL(request.url);
            return redirect(`/cards/limit-templates/system${url.search}`);
          },
        },
        {
          path: 'system',
          lazy: lazyComponent(
            () => import('@pages/client/card/cards-limit-templates-page'),
            'CardsLimitSystemTemplatesPage',
          ),
        },
        {
          path: 'custom',
          lazy: lazyComponent(
            () => import('@pages/client/card/cards-limit-templates-page'),
            'CardsLimitCustomTemplatesPage',
          ),
        },
      ],
    },
    {
      path: '/cards/:id/limit-template',
      lazy: lazyComponent(
        () => import('@pages/client/card/limit-setup-page'),
        'LimitSetupPage',
      ),
      children: [
        {
          index: true,
          loader: ({ params }) => redirect(`/cards/${params.id}/limit-template/system`),
        },
        {
          lazy: lazyComponent(
            () => import('@pages/client/card/limit-setup-page'),
            'SelectTemplatePage',
          ),
          children: [
            {
              path: 'system',
              lazy: lazyComponent(
                () => import('@pages/client/card/limit-setup-page'),
                'SystemTemplatesPage',
              ),
            },
            {
              path: 'custom',
              lazy: lazyComponent(
                () => import('@pages/client/card/limit-setup-page'),
                'CustomTemplatesPage',
              ),
            },
          ],
        },
        // а ось тут неправильно, бо це темплейт а не ліміт, і тягне він все з фіч ліміту шо не ок, потім після демо поправим
        {
          path: 'new',
          lazy: lazyComponent(
            () => import('@pages/client/card/limit-setup-page'),
            'ConfigureLimitPage',
          ),
        },
        {
          path: 'edit/:templateId',
          lazy: lazyComponent(
            () => import('@pages/client/card/limit-setup-page'),
            'EditTemplatePage',
          ),
        },
      ],
    },
  ],
};
